export const BLOB_CONFIG = {
  background: '#fff',
  uPositionFrequency: 1.0,
  uPositionStrength: 0.4,
  uSmallWavePositionFrequency: 0.6,
  uSmallWavePositionStrength: 0.8,
  uSmallWaveTimeFrequency: 0.2,
  uTimeFrequency: 0.4,
  roughness: 0.5,
  metalness: 0.5,
  envMapIntensity: 1.0,
  clearcoat: 0.0,
  clearcoatRoughness: 0.0,
  transmission: 0.0,
  wireframe: false,
  flatShading: false,
  autoRotate: true,
  autoRotateSpeed: 2.0,
};

export const DEFAULT_COLORS = {
  gradientColor1: '#d3d3d3',
  gradientColor2: '#d3d3d3',
  gradientColor3: '#d3d3d3',
};
